import {firestore} from './firebase';
import { collection, addDoc } from 'firebase/firestore';

const links = collection(firestore, "links");

export const createLink = async (data) => addDoc(links, data);
